import React from 'react';
import styled from 'styled-components';
import PrimaryButton from '~/src/components/common/forms/Button/PrimaryButton';
import { Colors } from '~/src/scss/common/style';

export default function UsdaResultBox({ food, setNutriFacts }): JSX.Element {
  return (
    <Container>
      <div>
        <b>{food.description}</b>
      </div>
      <div>
        <div style={{ float: 'right' }}>{food.gtinUpc}</div>
        <div>
          {food.brandName && (
            <>
              Brand: <b>{food.brandName}</b> by <b>{food.brandOwner}</b>
            </>
          )}
          Src: <b>{food.dataType}</b>
          <br />
          FDCID: {food.fdcId}
        </div>
        <br />
        {food.ingredients}
      </div>
      <PrimaryButton
        title="Select"
        onClick={() => {
          setNutriFacts(food);
        }}
      />
    </Container>
  );
}

const Container = styled('div')`
  padding: 15px;
  margin-bottom: 5px;
  background: rgba(239, 125, 0, 0.09);
  border: 2px solid ${Colors.newOrage};
  border-radius: 10px;
`;
